
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/repairs",
      function () {
        return require("private-next-pages/repairs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/repairs"])
      });
    }
  